import React from "react";
import { useDispatch } from "react-redux";
import { logout } from "../../store/actions/loginActions";
import { useNavigate } from "react-router";

function ProfileModal({ loginInfo, style = {}, onClose }) {
  const dispatch = useDispatch();
  const history = useNavigate();

  const goTo = (path) => {
    history(path);
    if (onClose) onClose();
  };

  const handleLogout = () => {
    dispatch(logout());
    history("/login");
    if (onClose) onClose();
  };

  return (
    <div className="absolute bg-white min-w-[220px] shadow-lg z-[100] rounded-[5px]" style={{ ...style }}>
      <div className="border-b border-gray-300 py-1 text-[#211F59]">
        <div
          className="px-[20px] py-[12px] cursor-pointer flex items-center gap-3 hover:bg-gray-100 transition-colors duration-150"
          onClick={() => goTo(`/userProfile/${loginInfo?.email}`)}
        >
          <i className="fas fa-user"></i>
          <span className="text-[15px]">Profile</span>
        </div>
      </div>
      <div className="border-b border-gray-300 py-1 text-[#211F59]">
        <div
          className="px-[20px] py-[12px] cursor-pointer flex items-center gap-3 hover:bg-gray-100 transition-colors duration-150"
          onClick={() => goTo(`/myTrips/${loginInfo?.id}`)}
        >
          <i className="fas fa-truck-moving"></i>
          <span className="text-[15px]">My Trips</span>
        </div>
      </div>
      <div className="border-b border-gray-300 py-1 text-[#211F59]">
        <div
          className="px-[20px] py-[12px] cursor-pointer flex items-center gap-3 hover:bg-gray-100 transition-colors duration-150"
          onClick={() => goTo(`/resetPassword/${loginInfo?.email}`)}
        >
          <i className="fas fa-unlock-alt"></i>
          <span className="text-[15px]">Change Password</span>
        </div>
      </div>
      <div className="py-1 text-[#211F59]">
        <div
          className="px-[20px] py-[12px] cursor-pointer flex items-center gap-3 hover:bg-gray-100 transition-colors duration-150"
          onClick={handleLogout}
        >
          <i className="fas fa-sign-out-alt"></i>
          <span className="text-[15px]">Log out</span>
        </div>
      </div>
    </div>
  );
}

export default ProfileModal;
